import React from 'react';
import { connect } from 'react-redux';
import { deleteTesAllStudentAnswer } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  deleteTesAllStudentAnswer,
};

function ModalDeleteAllStudentAnswer({
  deleteTesAllStudentAnswer,
  data,
  closeModal,
}) {
  const auth = data?.auth;
  const item = data?.item;
  const id = item?.tugasId;
  const history = data?.history;
  const screenWidth = useScreenWidth();

  function handleDelete() {
    deleteTesAllStudentAnswer({ auth, history, id });
    closeModal();
  }

  return (
    <Modal
      variant='danger'
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <p className='px-4 my-5 mx-1'>
        Apakah Anda yakin ingin menghapus{' '}
        <span className='has-text-weight-semibold has-text-danger'>
          Semua Tes
        </span>{' '}
        yang disubmit siswa?
      </p>
      <div className='flex justify-end align-center px-4 pt-2'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={handleDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteAllStudentAnswer);
